import React from 'react';
import { Colors, FontSize } from '@common/tokens';
import {
  InvoiceBulkActionButtons,
  MultipleLineItemExportButton,
} from '@pay-bill/components';
import { InvoiceListItemFragmentType } from '@pay-bill/graphql';

export const InvoiceBulkActionFooter = ({
  invoices,
  onFinish,
}: {
  invoices: InvoiceListItemFragmentType[];
  onFinish: () => void;
}) => (
  <div className="bulk-action-content">
    <footer className="bulk-action-footer">
      <div className="footer-element invoices-count">
        {invoices.length} {invoices.length > 1 ? 'invoices' : 'invoice'}{' '}
        selected.
      </div>
      <div className="footer-element">
        <MultipleLineItemExportButton
          entityType="invoice"
          onFinish={onFinish}
          entityIds={invoices.map((entity) => entity.id)}
        />
      </div>
      <div className="footer-element">
        <InvoiceBulkActionButtons invoices={invoices} onFinish={onFinish} />
      </div>
    </footer>
    <style jsx>{`
      .bulk-action-content {
        margin-top: 32px;
      }

      .footer-element {
        font-size: ${FontSize.md};
        margin-right: 10px;
      }

      .invoices-count {
        padding-top: 4px;
      }

      .bulk-action-footer {
        padding: 16px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        background-color: ${Colors.white};
        position: fixed;
        bottom: 0;
        left: 80px;
        width: calc(100% - 80px);
      }
    `}</style>
  </div>
);
